import { createStyles } from "@mantine/core";
import { IInlineFlexProps } from "./types";

export const useStyles = createStyles(
  (
    theme,
    {
      align: alignItems,
      columnGap,
      direction: flexDirection,
      gap,
      justify: justifyContent,
      rowGap,
      wrap: flexWrap,
    }: IInlineFlexProps,
  ) => ({
    box: {
      alignItems,
      columnGap,
      display: "inline-flex",
      flexDirection,
      gap,
      justifyContent,
      rowGap,
      flexWrap,
    },
  }),
);
